import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Stack from '@mui/material/Stack'
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'
import Label from 'components/Label'

export const parsePhoneNumber = phoneNumber => {
  const countryCode = phoneNumber.match(/^\+(\d+)/)?.[1]
  const number = phoneNumber.substring(countryCode?.length + 1)

  return {
    countryCode: countryCode?.trim?.(),
    number: number?.trim?.(),
    // countryCode: countryCode?.replace(/\s/g, ''),
    // number: number?.replace(/\s/g, '')
  }
}


const TelephoneInput = ({
  label,
  labelProps = {},
  defaultValue,
  defaultCountryCode,
  defaultNumber,
  onChange,
  ...props
}) => {
  const [phone, setPhone] = useState('')
  const [isValid, setIsValid] = useState(false)

  const handleChange = newValue => {
    setPhone(newValue)
    setIsValid(matchIsValidTel(newValue))
    onChange(newValue, {
      isValid: matchIsValidTel(newValue),
      fullNumber: newValue,
      ...parsePhoneNumber(newValue)
    })
  }

  useEffect(() => {
    const temp = defaultCountryCode && defaultNumber ? `+${defaultCountryCode} ${defaultNumber}` : defaultValue || ''
    setPhone(temp)
    setIsValid(matchIsValidTel(temp))
    onChange(temp, {
      isValid: matchIsValidTel(temp),
      fullNumber: temp,
      ...parsePhoneNumber(temp)
    })
  }, [defaultValue, defaultNumber, defaultCountryCode])

  return (
    <Stack
      gap={1}
    >
      {label && (
        <Label
          {...labelProps}
        >
          {label}
        </Label>
      )}
      <MuiTelInput 
        forceCallingCode
        focusOnSelectCountry
        defaultCountry="US"
        error={!isValid && phone.length > 0}
        // onlyCountries={['FR', 'BE']}
        value={phone} 
        onChange={handleChange}
        {...props}
      />
    </Stack>
  )
}

TelephoneInput.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
}

TelephoneInput.defaultProps = {
  defaultValue: '',
  onChange: () => {},
}

export default TelephoneInput